import React from 'react';
import { Typography, Box, List, ListItem, ListItemText, Link } from '@mui/material';
import LegalLayout from './LegalLayout';

const PrivacyPolicy: React.FC = () => {
  return (
    <LegalLayout title="Политика за поверителност">
      <Typography paragraph>
        "Голдън Букс" ЕООД се ангажира да защитава Вашата поверителност и 
        лични данни в съответствие с Общия регламент за защита на данните (GDPR) 
        и българското законодателство.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        1. Администратор на лични данни
      </Typography>
      <Typography paragraph>
        Администратор на Вашите лични данни е "Голдън Букс" ЕООД със седалище 
        София, България. За въпроси относно обработката на лични данни може 
        да се свържете с нас на info@goldenbooks.bg.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        2. Събирани лични данни
      </Typography>
      <Typography paragraph>
        При ползване на нашия сайт и услуги събираме следните лични данни:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Идентификационни данни" 
            secondary="Име, фамилия, имейл адрес, телефонен номер" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Адресни данни" 
            secondary="Адрес за доставка и фактуриране" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Данни за поръчки" 
            secondary="История на поръчки, предпочитания, метод на плащане" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Технически данни" 
            secondary="IP адрес, данни от браузъра, cookies" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        3. Цел на обработката
      </Typography>
      <Typography paragraph>
        Вашите лични данни се обработват за следните цели:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Изпълнение на поръчки и договорни задължения" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Комуникация с клиенти и обслужване" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Подобряване на услугите и потребителското изживяване" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Изпращане на маркетингови съобщения (с Ваше съгласие)" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Спазване на законови изисквания" />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        4. Правно основание
      </Typography>
      <Typography paragraph>
        Обработването на Вашите лични данни се основава на:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Изпълнение на договор" 
            secondary="за обработка на поръчки и доставка" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Законен интерес" 
            secondary="за подобряване на услугите и комуникация" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Съгласие" 
            secondary="за маркетингови съобщения и cookies" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Законово задължение" 
            secondary="за съхраняване на счетоводна документация" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        5. Споделяне на данни
      </Typography>
      <Typography paragraph>
        Вашите лични данни могат да бъдат споделени с:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Куриерски фирми" 
            secondary="за доставка на поръчки" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Платежни системи" 
            secondary="за обработка на плащания" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="IT доставчици" 
            secondary="за поддръжка на системите" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Компетентни органи" 
            secondary="при законово изискване" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        6. Срок на съхранение
      </Typography>
      <Typography paragraph>
        Вашите лични данни се съхраняват:
      </Typography>
      <List>
        <ListItem>
          <ListItemText 
            primary="Данни за поръчки" 
            secondary="5 години за счетоводни цели" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Маркетингови данни" 
            secondary="до оттегляне на съгласието" 
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary="Технически данни" 
            secondary="до 2 години" 
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        7. Вашите права
      </Typography>
      <Typography paragraph>
        Съгласно GDPR имате следните права:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Право на достъп до Вашите лични данни" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Право на корекция на неточни данни" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Право на изтриване ('право да бъдете забравени')" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Право на ограничаване на обработката" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Право на преносимост на данните" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Право на възражение срещу обработката" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Право на оттегляне на съгласието" />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        8. Безопасност на данните
      </Typography>
      <Typography paragraph>
        Прилагаме съответни технически и организационни мерки за защита на 
        Вашите лични данни срещу неоторизиран достъп, промяна, разкриване или 
        унищожаване, включително:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="SSL криптиране при предаване на данни" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Ограничен достъп до данните само за упълномощени лица" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Редовни резервни копия и актуализации на системите" />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        9. Cookies
      </Typography>
      <Typography paragraph>
        Нашият сайт използва cookies за подобряване на функционалността и 
        потребителското изживяване. За повече информация вижте нашата{' '}
        <Link href="/legal/cookies" color="primary">
          Политика за cookies
        </Link>.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        10. Контакт
      </Typography>
      <Typography paragraph>
        За въпроси относно обработката на Вашите лични данни или за упражняване 
        на Вашите права, моля свържете се с нас:
      </Typography>
      <Typography paragraph>
        Имейл: info@goldenbooks.bg<br />
        Телефон: 0895628293<br />
        Адрес: София, България
      </Typography>
      <Typography paragraph>
        Имате право да подадете жалба до Комисията за защита на личните данни, 
        ако считате, че Вашите права са нарушени.
      </Typography>
    </LegalLayout>
  );
};

export default PrivacyPolicy;